import {
  VERIFY_EMAIL_ALERT_RECIPIENT
} from './constants'

export function getVerifyEmailAlertRecipient (params) {
  return axios
    .get(VERIFY_EMAIL_ALERT_RECIPIENT, {params, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}



// WEBPACK FOOTER //
// ./app/api/verifyEmailAlertRecipient/email-alert-recipients.js